/* @flow */
import urlencode from 'urlencode';

type Config = { apiRoot: string, appRoot: string };

class Endpoints {
  apiRoot: string;
  appRoot: string;

  constructor(config: Config) {
    this.apiRoot = config.apiRoot;
    this.appRoot = config.appRoot;
  }

  masterDomain(): string {
    const m = /^https?:\/\/(.*)/.exec(this.appRoot);
    return (m ? m[1] : this.appRoot);
  }

  login(): string {
    const back = urlencode.encode(window.location);
    return `${this.appRoot}/login?back=${back}`;
  }

  oldDashboard(): string {
    return `${this.appRoot }/myprofile`;
  }

  eventsPage(): string { return `${this.appRoot}/profile/events`; }

  currentUser(): string { return this._api('/current-user'); }

  statsShopFrames(dateFrom: string, dateTo: string): string { 
    return this._api(`/current-user/stats/shop-frames?date_from=${dateFrom}&date_to=${dateTo}`);
  }
  
  statsOrders(dateFrom: string, dateTo: string): string { 
    return this._api(`/current-user/stats/orders?date_from=${dateFrom}&date_to=${dateTo}`);
  }

  statsItems(): string { return this._api('/items'); }

  itemData(itemIds: Array<number>): string {
    let url = this._api('/item-details?');
    itemIds.forEach((itemId) => {
      url += `item_ids[]=${itemId}&`;
    });
    return url.slice(0, -1);
  }

  itemCustomisationData(itemId) {
    return this._api('/current-user/item-customisations/' + itemId);
  }

  newReviewOrderData(orderId) {
    return this._api(`/current-user/orders/${orderId}/review`);
  }

  newAnonReviewOrderData(orderId) {
    return this._api(`/orders/${orderId}/review`);
  }

  reviewSubmitted() {
    return this._app('/current-user/reviews?posted=true');
  }

  anonReviewSubmitted() {
    return this._app('?review-submitted=true');
  }

  _app(path: string): string {
    return `${this.appRoot}${path}`;
  }

  _api(path: string): string {
    return `${this.apiRoot}${path}`;
  }

  support() {
    return 'https://folksy.uservoice.com';
  }

}

export default Endpoints;



// WEBPACK FOOTER //
// ./src/utils/endpoints.js